import { Store } from 'pullstate';
import doLogout from './utils/auth/logout';

const initialAuthState = () => ({
  isLoggedIn: false,
  user: null,
});

const store = new Store({
  auth: initialAuthState(),
  authHelperStates: {
    isCheckingAuth: true,
    isLoggingOut: false,
  },
});

export default store;

export function login(user) {
  store.update((s) => {
    s.auth = {
      isLoggedIn: true,
      user,
    };
  });
}

export function setAuthStateAsIntiital() {
  store.update((s) => {
    s.auth = initialAuthState();
  });
}

export function logout() {
  store.update((s) => {
    s.authHelperStates.isLoggingOut = true;
  });

  doLogout();
  window.location.reload();
  return;
  // .then(noop)//setAuthStateAsIntiital)
  // .catch(noop)
  // .finally(() => {
  //   store.update((s) => {
  //     s.authHelperStates.isLoggingOut = false;
  //   });
  //   window.location.reload();
  // });
}
